import * as types from './types';
import firebaseService from 'Services/firebaseService';

export function getPlanData() {
  return dispatch => {
    firebaseService
      .getPlanData()
      .then(response => {
        dispatch({
          type: types.SET_PLAN_DATA,
          plans: response,
        });
      })
      .catch(error => {
        // todo should have some dispatch error here
        console.warn('Error getting plan data : ', error);
      });
  };
}
